import React from 'react';

import { Box, Tooltip as MuiTooltip } from '@mui/material';

type MuiTooltipProps = Omit<Parameters<typeof MuiTooltip>[0], 'children'>;

type Props = MuiTooltipProps & {
  children: string | JSX.Element;
};

export default function TooltipUnderline({ children, ...props }: Props): JSX.Element {
  return (
    <MuiTooltip {...props}>
      <Box component="span" sx={{ borderBottom: props.title ? '1px dashed currentColor' : 'none' }}>
        {children}
      </Box>
    </MuiTooltip>
  );
}
